import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import {
  FormControl,
  FormControlProps,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import React, { useId } from "react";

type MultiSelectProps<T extends React.Key> = {
  label: string;
  value: T[];
  onChange: (value: T[]) => void;
  options: { id: T; name: string }[];
  readOnly?: boolean;
} & FormControlProps;

const MultiSelect = <T extends React.Key>(props: MultiSelectProps<T>) => {
  const { label, value, onChange, options, readOnly, ...formControlProps } = props;

  const id = useId();

  return (
    <FormControl variant="filled" {...formControlProps}>
      <InputLabel id={id}>{label}</InputLabel>
      <Select
        labelId={id}
        multiple
        value={value}
        readOnly={readOnly}
        renderValue={(selected) =>
          options
            ?.filter((option) => selected?.includes(option.id))
            .map((option) => option.name)
            .join(", ")
        }
        MenuProps={{
          PaperProps: {
            style: {
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
            },
          },
        }}
      >
        {options?.map((option) => {
          const selected = value.includes(option.id) ?? false;
          const SelectionIcon = selected ? CheckBox : CheckBoxOutlineBlank;

          return (
            <MenuItem
              key={option.id}
              onClick={() => {
                if (selected) {
                  onChange(value.filter((id) => id !== option.id));
                } else {
                  onChange([...value, option.id]);
                }
              }}
            >
              <SelectionIcon
                fontSize="small"
                color={selected ? "primary" : "disabled"}
                style={{ marginRight: 8, padding: 9, boxSizing: "content-box" }}
              />
              <ListItemText primary={option.name} />
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default MultiSelect;
